const config = {
  userInfo: 600,
  kyc: 600,
  btcValuation: 10,
  userAsset: 10,
};

export default config;
